import _get from 'lodash.get';

function getAdItem(adObj, isCTN, position) {
  let adItem = {};
  if (isCTN) {
    adItem.isCTN = true;
    adItem.adCode = adObj.slotId;
  } else {
    adItem = { ...adObj, divId: adObj.divId + position };
  }

  return adItem;
}

function getAdInsert(inlineAds, ads, position, isMobile, isGrid2Col) {
  let adInsert;
  if (!ads || !(inlineAds && inlineAds.length)) {
    return adInsert;
  }

  const adsData = {
    ads,
  };

  let matchedAds = inlineAds.filter(adRef => {
    let matched = false;
    if (adRef.pos === adRef.repeatAfter && position % adRef.pos === 0) {
      matched = true;
    } else if ((position - adRef.pos) % adRef.repeatAfter === 0) {
      matched = true;
    } else if (
      !isMobile &&
      !adRef.repeatAfter &&
      position === adRef.pos &&
      isGrid2Col &&
      adRef.viewtype === '2colgrid'
    ) {
      //Betway banner condition for sports blog - WEB / 2colgrid
      matched = true;
    } else if (
      !isMobile &&
      !adRef.repeatAfter &&
      position === adRef.pos &&
      !isGrid2Col &&
      adRef.viewtype === '3colgrid'
    ) {
      //Betway banner condition for sports blog - WEB / 3colgrid
      matched = true;
    } else if (isMobile && !adRef.repeatAfter && position === adRef.pos) {
      //Betway banner condition for sports blog - WAP
      matched = true;
    }
    return matched;
  });

  if (!matchedAds.length) {
    return adInsert;
  }

  // 2 mrec ads valid for desktop 3 col grid only
  if (!isMobile && !isGrid2Col && matchedAds.length > 1) {
    matchedAds = matchedAds.slice(0, 2);
    adInsert = {
      tn: 'ads',
      data: [],
    };
    matchedAds.forEach(ad => {
      const isCTN = ad.ref.indexOf('ads.ctn') === 0;
      const adObj = _get(adsData, ad.ref, undefined);
      if (!adObj) {
        return;
      }
      adInsert.data.push(getAdItem(adObj, isCTN, position));
    });
  } else {
    matchedAds = matchedAds.slice(0, 1);
    const ad = matchedAds[0];
    const isCTN = ad.ref.indexOf('ads.ctn') === 0;
    const adObj = _get(adsData, ad.ref, undefined);

    adInsert = getAdItem(adObj, isCTN, position);
    adInsert.tn = 'ad';
  }

  return adInsert;
}

function getWidgetInserts(position, widgets) {
  return widgets.filter(widget => widget.pos === position);
}

function insertWidget(widgets, inlineAds, dataList, ads, isMobile, isGrid2Col) {
  let data = [];

  dataList.forEach((item, index) => {
    const position = index + 1;
    const adInsert = getAdInsert(
      inlineAds,
      ads,
      position,
      isMobile,
      isGrid2Col,
    );
    const widgetInserts = getWidgetInserts(position, widgets);

    // If any widget has prepend flag set & to be inserted before the timeline item
    if (widgetInserts.length) {
      const widgetInsertsPerpend = widgetInserts.filter(
        widget => widget.prepend === true,
      );
      if (widgetInsertsPerpend.length) {
        data = data.concat(widgetInsertsPerpend);
      }
    }

    data.push(item);

    if (adInsert) {
      data.push(adInsert);
    }

    // Widgets don't have prepend flag & to be inserted after the timeline item
    if (widgetInserts.length) {
      const widgetInsertsappend = widgetInserts.filter(
        widget => !widget.prepend,
      );
      if (widgetInsertsappend.length) {
        data = data.concat(widgetInsertsappend);
      }
    }
  });

  return data;
}

export function widgetInsertInTimeLine(widgets, inlineAds, dataList, ads) {
  const filterWidget = [];
  const updatedWidgets = widgets.filter(widget => {
    if (filterWidget.indexOf(widget.tn) !== -1) return false;
    return widget.pos;
  });
  return insertWidget(updatedWidgets, inlineAds, dataList, ads, true, false);
}

export function widgetInsertInTimeLineWeb(
  widgets,
  inlineAds,
  dataList,
  ads,
  isGrid2Col,
) {
  const filterWidget = ['covid19WidgetInsert'];
  const updatedWidgets = widgets.filter(widget => {
    if (filterWidget.indexOf(widget.tn) !== -1) return false;
    return widget.pos;
  });
  return insertWidget(
    updatedWidgets,
    inlineAds,
    dataList,
    ads,
    false,
    isGrid2Col,
  );
}

export function addAffilateWidgetinWidgets(widgets, isMobile) {
  const affiliateWidget = {
    tn: 'aff_timeline_insert',
    pos: isMobile ? 6 : 10,
  };

  widgets.push(affiliateWidget);

  return widgets;
}

export const addRenewalNudgeInWidgets = (widgets, isMobile) => {
  const renewNudge = {
    tn: 'primeinlinewidget',
    pos: isMobile ? 1 : 1,
  };
  widgets.push(renewNudge);
  return widgets;
};
